interface IProps {
  area?: string;
}

const WarningsPanelHeaderLoading = ({ area }: IProps) => (
  <li className="WeatherWarning-bar-warning-item WeatherWarning-bar-warning-item--plain" style={{ height: '100%' }}>
    Loading warnings
    {area && <span>&nbsp;for {area}</span>}
    ...
  </li>
);

export { WarningsPanelHeaderLoading };
